import { createContext } from 'react';
import { applicationContext } from './application-context.js';
const FoundationApplicationContext = createContext(applicationContext);
FoundationApplicationContext.displayName = 'FoundationApplicationContext';
export { FoundationApplicationContext, };
//# sourceMappingURL=foundation-application-context.js.map